import _defineProperty from "/home/cleavr/www.eateryberlin.com/releases/20241113105556874/packages/frontend/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/cleavr/www.eateryberlin.com/releases/20241113105556874/packages/frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/cleavr/www.eateryberlin.com/releases/20241113105556874/packages/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Creates the variable meta data for a single set
 * @param {string} prefix - A string that helps to classify the created vars.
 * @param {object} set - A object with sets of variables to build referencing the tokens provided (key will be the name for the conditional class).
 * @param {object} tokens - Abstract values might be used by this set.
 */
var createVars = function createVars(prefix, set, tokens) {
  return Object.entries(set).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        token = _ref2[1];

    return [].concat(_toConsumableArray(acc), [{
      var: "--".concat(prefix).concat(name),
      val: tokens[token],
      alias: name
    }]);
  }, []);
}; // .map(([name, token]) => ({
//   var: `--${prefix}${name}`,
//   val: tokens[token],
//   alias: name,
// }));

/**
 * Cuts
 * @param {string} prefix - A string that helps to classify the created vars.
 * @param {object} set - A object with sets of variables to build referencing the tokens provided (key will be the name for the conditional class).
 * @param {object} tokens - Abstract values might be used by this set.
 */


var createResponsiveVars = function createResponsiveVars(prefix, set, tokens) {
  return {
    Test: "RING"
  };
};
/**
 * Creates an object containing variables for interoperable use.
 * @param {string} prefix - A string that helps to classify the created vars.
 * @param {object} sets - A object with sets of variables to build referencing the tokens provided (key will be the name for the conditional class).
 * @param {object} tokens - Abstract values being used by the sets.
 */


var createThemeVars = function createThemeVars() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var sets = arguments.length > 1 ? arguments[1] : undefined;
  var tokens = arguments.length > 2 ? arguments[2] : undefined;
  prefix += prefix.length ? "-" : "";
  return Object.entries(sets).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        setName = _ref4[0],
        set = _ref4[1];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, setName, Array.isArray(set) ? createResponsiveVars() : createVars(prefix, set, tokens)));
  }, {});
};

var createMap = function createMap(vars) {
  return (vars.default || Object.values(vars)[0]).reduce(function (acc, cur) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur.alias, "var(".concat(cur.var, ")")));
  }, {});
};
/**
 * Creates a string in css syntax
 * @param {string} set - Name of the set.
 * @param {array} vars - Array of sets of objects with var, val, alias.
 */


var writeVars = function writeVars(set, vars) {
  return "".concat(set === "default" ? ":root" : ".theme-".concat(set), " { ").concat(vars.reduce(function (acc, cur) {
    return acc += "".concat(cur.var, ":").concat(cur.val, ";");
  }, ""), " }");
};
/**
 * Resolves a var from a given domain, set and name
 * @param {object} domain - Provides the config of a given domain.
 * @param {string} name - The name of the var to search for.
 */


var getVar = function getVar(domain, name) {
  return domain.map[name];
};

export default createThemeVars;
export { createMap, getVar, writeVars };